import axios from "axios";
import { baseURL } from "utils/env";
import { serverErrors } from "./handleServerError";
const commonHeaders = {
  "Content-Type": "application/json",
  Accept: "application/json",
};
const getHeader = () => {
  const token = "";
  return { ...commonHeaders, ...{ Authorization: "Bearer " + token } };
};
export const instanceAxios = axios.create({
  baseURL,
  headers: getHeader(),
});

instanceAxios.interceptors.response.use(
  (response) => successResponce(response),
  (error) => handleErrors(error)
);

instanceAxios.interceptors.request.use(
  (config) => {
    config.headers = getHeader();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
const successResponce = (result) => {
  const { data = {} } = result;
  return data;
};

const handleErrors = (error) => {
  if (error && error.response && error.response.status) {
    let statusCode = error.response.status;
    switch (statusCode) {
      case 401:
        window.localStorage.clear();
        break;
      case 400:
        // handle
        break;
      case 404:
        // handle
        break;
      default:
        // optionally log or throw
        console.warn(`Unhandled status code: ${statusCode}`);
    }
  }
  return Promise.reject(serverErrors(error));
};
